import { useQueryClient } from '@tanstack/react-query';
import type { Event } from 'models';
import { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { updateBookmarkInFeeds, updateBookmarksFeed } from 'features/bookmark/utils';
import { getNodeEventDetailQueryKey } from '../queries/keys';

export const useUpdateNodeEventBookmark = () => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ event }: { event: Event }) => {
      const isBookmarked = !event.isBookmarked;

      queryClient.setQueriesData<Event>(
        { queryKey: getNodeEventDetailQueryKey({ eventId: event.id }) },
        (cachedEvent) => {
          if (!cachedEvent) {
            return cachedEvent;
          }

          return { ...cachedEvent, isBookmarked };
        },
      );

      updateBookmarkInFeeds({ id: event.id, isBookmarked, queryClient });
      // Event from event detail is not shaped like a node event in bookmarks, we can only fetch it again, cannot add it
      updateBookmarksFeed({ id: event.id, isBookmarked, queryClient });
    },
    [queryClient],
  );
};
